module.exports = __webpack_public_path__ + "static/media/c_logo.a66a869f.png";